import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import FlowNameLabel from 'flow-doctor-lib/components/common/FlowNameLabel';
import LabelAndSubInfo from 'flow-doctor-lib/components/timeline/labels/LabelAndSubInfo';
import { getCanvasUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionExecutionTimelineItemLabel = ({
  flowId,
  logItem
}) => {
  return /*#__PURE__*/_jsx(LabelAndSubInfo, {
    label: /*#__PURE__*/_jsx(UITruncateString, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.actionExecutionHistory.enrolledInto_jsx",
        elements: {
          ViewLink: UILink,
          b: 'b',
          FlowNameLabel
        },
        options: {
          viewLink: {
            external: true,
            href: getCanvasUrl({
              portalId: logItem.data.portalId,
              flowId
            })
          },
          flowNameLabel: {
            portalId: logItem.data.portalId,
            flowId
          }
        }
      })
    }),
    subInfoBullets: [/*#__PURE__*/_jsx(UITruncateString, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.actionExecutionHistory.enrolledFrom_jsx",
        elements: {
          ViewLink: UILink,
          b: 'b',
          FlowNameLabel
        },
        options: {
          viewLink: {
            external: true,
            href: getCanvasUrl({
              portalId: logItem.data.portalId,
              flowId: logItem.data.flowId
            })
          },
          flowNameLabel: {
            portalId: logItem.data.portalId,
            flowId: logItem.data.flowId
          }
        }
      })
    }, 0)]
  });
};
export default ActionExecutionTimelineItemLabel;